import IndexTable from '@lib/components/index-table/IndexTable'
import ProjectConfigurationIndexTableRow from './ProjectConfigurationIndexTableRow'
import IndexTableFeature from '../index-table/IndexTableFeature';

export default class ProjectConfigurationsIndexTable extends IndexTable {
    rowComponentClass = ProjectConfigurationIndexTableRow

    static defaultProps = {
        keyName: 'guid'
    }

    getRowComponentProps(result, columns, options) {
        var base = super.getRowComponentProps(result, columns, options)
        return {
            ...base,
            projectId: this.props.projectId,
            canSetConfigurationOptional: this.props.canSetConfigurationOptional,
            onConfiguratioRowPriceChanged: options.onConfiguratioRowPriceChanged,
            onProductSerialNumberChanged: options.onProductSerialNumberChanged,
            onOptionSelectClick: options.onOptionSelectClick,
            onOptionGroupNameChange: options.onOptionGroupNameChange,
            onCopyAsOptionalRowClick: this.props.onCopyAsOptionalRowClick
        }
    }

    renderBeforeRow(result, columns) {
        if (!this.props.canSetConfigurationOptional || !this.hasGroupStartAttr(result)) {
            return <React.Fragment/>
        }

        return (
            <tr>
                <td style={{background: '#f5f5f7'}} colSpan={columns.length}>
                    <input type="text" value={result.optionGroupName}
                           onChange={e => this.props.options.onOptionGroupNameChange(result.optionGroupGuid, e.target.value)}
                           className="project-configrations-versions-option-group-name-input"
                           placeholder={__('Overal name')}/>
                </td>
                {this.isFeatureRequested(IndexTableFeature.ActionButtons) && <td style={{background: '#f5f5f7'}}></td>}
            </tr>
        )
    }

    renderAfterRow(result, columns) {
        if (!this.props.canSetConfigurationOptional || !this.hasGroupEndAttr(result)) {
            return <React.Fragment/>
        }

        return (
            <tr>
                <td style={{background: '#f5f5f7'}} colSpan={columns.length}></td>
                {this.isFeatureRequested(IndexTableFeature.ActionButtons) && <td style={{background: '#f5f5f7'}}></td>}
            </tr>
        )
    }

    hasGroupStartAttr = (result) => {
        if (!result.optionGroupGuid) {
            return false;
        }

        return this.props.results.filter(c => c.optionGroupGuid == result.optionGroupGuid)[0].guid === result.guid;
    }

    hasGroupEndAttr = (result) => {
        if (!result.optionGroupGuid) {
            return false;
        }

        var currentResultIndex = this.props.results.findIndex(x => x.guid === result.guid);
        var nextResult = this.props.results.length > currentResultIndex + 1 ? this.props.results[currentResultIndex + 1] : null;
        return nextResult != null && nextResult.optionGroupGuid == null;
    }
}